import { MixpanelProvider } from 'common-ui/mixpanel'
import { mixpanel } from './mixpanel'
import { PageTracking } from './PageTracking'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/nunito-sans/700.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import { BillingApiProvider } from './api/billing/billing-context'
import { AuthProvider } from './components/login/Auth'
import { routes } from './routes/routes'
import { LocalStorageProvider } from './local-storage'
import { ConfirmDialogProvider } from './components/common/ConfirmationDialog'
import { ThemeSwitcher } from './theme/ThemeSwitcher'

const App = () => (
    <LocalStorageProvider>
        <BillingApiProvider>
            <ThemeSwitcher>
                <ConfirmDialogProvider>
                    <AuthProvider>
                        <BrowserRouter>
                            <PageTracking />
                            {routes}
                        </BrowserRouter>
                    </AuthProvider>
                </ConfirmDialogProvider>
            </ThemeSwitcher>
        </BillingApiProvider>
    </LocalStorageProvider>
)

mixpanel.init()

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
    <StrictMode>
        <MixpanelProvider value={mixpanel}>
            <App />
        </MixpanelProvider>
    </StrictMode>
)
